import { render, staticRenderFns } from "./AdminCategoryTypes.vue?vue&type=template&id=85aaeb56"
import script from "./AdminCategoryTypes.vue?vue&type=script&lang=js"
export * from "./AdminCategoryTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85aaeb56')) {
      api.createRecord('85aaeb56', component.options)
    } else {
      api.reload('85aaeb56', component.options)
    }
    module.hot.accept("./AdminCategoryTypes.vue?vue&type=template&id=85aaeb56", function () {
      api.rerender('85aaeb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminCategoryTypes.vue"
export default component.exports